import { useState } from "react";

import ListUnsuitableContainer from "@/components/shared/business/ListUnsuitableContainer/ListUnsuitableContainer";
import { UNSUITABLE_REASON_KEYS } from "@/components/shared/business/UnsuitableReason/constants/unsuitableReason.constants";
import { useCtgListFilterQuery } from "@api/ctg/ctgList/useCtgListFilter";
import { DRAFT_STATUS_CODE } from "@constants/draftStatusCode.constants";
import { formatDate } from "@utils/formatDate";
import { handleCtgError } from "@utils/handleDraftError";

import CtgListCompanyShell from "./components/CtgListCompanyShell/CtgListCompanyShell";
import CtgListStatusContainer from "./components/CtgListStatusContainer/CtgListStatusContainer";
import CtgTitleContainer from "./components/CtgTitleContainer/CtgTitleContainer";
import * as S from "./CtgListTableBody.style";
import { EMPTY_SHELL_VALUE } from "../../constants/ctgListTable.constants";

const EDITOR_LIST: ("mcEditorName" | "ftEditor2Name")[] = [
  "mcEditorName",
  "ftEditor2Name",
];

const WRITE_DATE_LIST = ["writeStartDt", "writeEndDt"];

const CtgListTableBody = () => {
  const [activeModalId, setActiveModalId] = useState<number | null>(null);

  const { data: ctgListData, refetch: updateCtgList } = useCtgListFilterQuery();

  return (
    <S.CtgListTableBody>
      {ctgListData?.data.map((ctgListItem) => {
        return (
          <S.CtgListTableTr
            key={`row-${ctgListItem.id}`}
            isError={handleCtgError(ctgListItem)[0]}
          >
            <S.CtgListTableId>
              {ctgListItem?.id || EMPTY_SHELL_VALUE}
            </S.CtgListTableId>
            <S.CtgListTablePressId>
              {ctgListItem?.registryId || EMPTY_SHELL_VALUE}
            </S.CtgListTablePressId>
            <S.CtgListTableRegistryAgency>
              {ctgListItem?.registryAgency || EMPTY_SHELL_VALUE}
            </S.CtgListTableRegistryAgency>
            <S.RegistryDate>
              {ctgListItem?.registryDate || EMPTY_SHELL_VALUE}
            </S.RegistryDate>
            <S.CtgListTableCompany>
              <CtgListCompanyShell
                companyName={ctgListItem?.organizationName || []}
              />
            </S.CtgListTableCompany>
            <S.CtgListTableCompany>
              <CtgListCompanyShell
                companyName={ctgListItem?.sponsorName || []}
              />
            </S.CtgListTableCompany>
            <S.CtgListTableCompany>
              <CtgListCompanyShell
                companyName={ctgListItem?.collaboratorName || []}
              />
            </S.CtgListTableCompany>

            <S.PressListTableUnsuitable
              isUnsuitable={
                ctgListItem.draftArticleStatusHighest ===
                DRAFT_STATUS_CODE.unsuitable
              }
              isModalOpen={activeModalId === ctgListItem.id}
            >
              <ListUnsuitableContainer
                onModalStateChange={(isOpen) => {
                  if (isOpen) {
                    setActiveModalId(ctgListItem?.id || null);
                  } else if (activeModalId === ctgListItem.id) {
                    setActiveModalId(null);
                  }
                }}
                id={Number(ctgListItem.id)}
                articleRejectReason={ctgListItem?.articleRejectReason || ""}
                duplArticleId={null}
                draftArticleStatusHighest={
                  ctgListItem.draftArticleStatusHighest
                }
                mcEditorName={ctgListItem.mcEditorName}
                aiDone={ctgListItem.aiDone}
                unsuitableReasonUsageType={UNSUITABLE_REASON_KEYS.ctgList}
              />
            </S.PressListTableUnsuitable>

            <CtgTitleContainer
              ctgListItem={ctgListItem}
              updateCtgList={updateCtgList}
              ctgListData={ctgListData?.data}
            />

            <S.StatusTableData
              key={ctgListItem.id}
              code={ctgListItem.draftArticleStatusHighest}
            >
              <CtgListStatusContainer data={ctgListItem} />
            </S.StatusTableData>

            {WRITE_DATE_LIST.map((dateKey) => (
              <S.PressListTableDate key={dateKey}>
                {ctgListItem[dateKey as keyof typeof ctgListItem]
                  ? formatDate(
                      ctgListItem[
                        dateKey as keyof typeof ctgListItem
                      ] as string,
                      "YY.MM.DD HH:mm:ss",
                    )
                  : EMPTY_SHELL_VALUE}
              </S.PressListTableDate>
            ))}

            {EDITOR_LIST.map((editor) => (
              <S.CtgListTableEditor key={editor}>
                {ctgListItem[editor] || EMPTY_SHELL_VALUE}
              </S.CtgListTableEditor>
            ))}
          </S.CtgListTableTr>
        );
      })}
    </S.CtgListTableBody>
  );
};

export default CtgListTableBody;
